import { LoadboardLabel, LoadboardValue, CommodityValue, NotSpecifiedValue } from "@/components/dataPages/loadboard";
import { getNumberWithCommas } from "@/utils/text";
import { TranslatedText } from "@/components/common/text";

export const LoadboardCargoInfo = ({ load }) => {
    return (
        <div className="w-full bg-cm-p-surface rounded-lg grid grid-cols-[132px_minmax(0,1fr)] gap-x-8 gap-y-4 p-4">
            <div className="flex flex-col gap-1">
                <LoadboardLabel text="Distance" />
                {load.loadDistance ? (
                    <LoadboardValue className="font-medium whitespace-nowrap">
                        {getNumberWithCommas(load.loadDistance, true)} <TranslatedText text="mi" />
                        {load.deadheadDistance ? (
                            <span className="ml-2 text-sm font-normal text-cm-p-text-secondary">
                                {getNumberWithCommas(load.deadheadDistance, true)} <TranslatedText text="DH" />
                            </span>
                        ) : null}
                    </LoadboardValue>
                ) : (
                    <NotSpecifiedValue />
                )}
            </div>
            <div className="flex flex-col gap-1 min-w-0">
                <LoadboardLabel text="Commodity" />
                <CommodityValue load={load} />
            </div>
            <div className="flex flex-col gap-1">
                <LoadboardLabel text="Load weight" />
                {load.loadWeight ? (
                    <LoadboardValue className="font-medium whitespace-nowrap">
                        {getNumberWithCommas(load.loadWeight, true)} <TranslatedText text="lbs" />
                    </LoadboardValue>
                ) : (
                    <NotSpecifiedValue />
                )}
            </div>
            <div className="flex flex-col gap-1 min-w-0">
                <LoadboardLabel text="Required equipments" />
                {load.humanReadableEquipment ? (
                    <LoadboardValue className="font-medium">{load.humanReadableEquipment}</LoadboardValue>
                ) : (
                    <NotSpecifiedValue />
                )}
            </div>
        </div>
    );
};
